const TEST_PROCESS_STEP_START = 'inicio';
const TEST_PROCESS_STEP_STEP_1 = 'paso 1 - experiencia mercado financieros';
const TEST_PROCESS_STEP_STEP_2 = 'paso 2 - nivel de estudios';
const TEST_PROCESS_STEP_STEP_3 = 'paso 3 - cultura financiera';
const TEST_PROCESS_STEP_STEP_4 = 'paso 4 - experiencia en inversion';
const TEST_PROCESS_STEP_STEP_5 = 'paso 5 - objetivo';
const TEST_PROCESS_STEP_STEP_6 = 'paso 6 - tiempo';
const TEST_PROCESS_STEP_STEP_7 = 'paso 7 - capacidad para asumir perdidas';
const TEST_PROCESS_STEP_STEP_8 = 'paso 8 - ingresos y gastos';
const TEST_PROCESS_STEP_STEP_9 = 'paso 9 - inversion sobre patrimonio';
const TEST_PROCESS_STEP_STEP_10 = 'paso 10 - expectativa de reservas';
const TEST_PROCESS_STEP_SUCCESS = 'paso exito - resultado';
const TEST_PROCESS_STEP_FAILURE = 'paso error - no idoneo';
const TEST_PROCESS_STEP = {
    1: TEST_PROCESS_STEP_STEP_1,
    2: TEST_PROCESS_STEP_STEP_2,
    3: TEST_PROCESS_STEP_STEP_3,
    4: TEST_PROCESS_STEP_STEP_4,
    5: TEST_PROCESS_STEP_STEP_5,
    6: TEST_PROCESS_STEP_STEP_6,
    7: TEST_PROCESS_STEP_STEP_7,
    8: TEST_PROCESS_STEP_STEP_8,
    9: TEST_PROCESS_STEP_STEP_9,
    10: TEST_PROCESS_STEP_STEP_10,
};
const TEST_PROCESS_STEP_ERROR = 'error';
const PROCESS_TYPE_ROBO = 'proc-robo-';
const PROCESS_TYPE_ROBO_TI = PROCESS_TYPE_ROBO + 'test-idoneidad';
const PROCESS_TYPE_GBI = 'proc-gbi-';
const PROCESS_TYPE_GBI_TI = PROCESS_TYPE_GBI + 'test-idoneidad';
const TEST_PROCESS_DETAIL_FAILURE = 'no-idoneo';
const EVENT_CATEGORY_SUITABILITY_TEST = 'test idoneidad';
const EVENT_ACTION_MODAL_VIEW = 'vista modal salir';
const EVENT_ACTION_EXIT_TEST = 'salir modal - salir';
const EVENT_ACTION_RETURN = 'volver';
const EVENT_ACTION_SUITABILITY_TEST_GOAL_SELECTION = 'eleccion de objetivo';
const EVENT_DETAIL_SUITABILITY_TEST_INVESTMENT_GOAL = {
    answer1: 'inversión especulativa a corto plazo',
    answer2: 'mantener mi patrimonio con un riesgo muy controlado',
    answer3: 'construir moderadamente mi patrimonio',
    answer4: 'aumentar significativamente mi patrimonio',
};
const EVENT_CATEGORY_SUITABILITY_TEST_MODAL = 'modal test de idoneidad';
const EVENT_ACTION_CONTINUE = 'continuar';
const EVENT_CATEGORY_INVESTMENT_PLAN = 'estrategia de inversion';
const EVENT_ACTION_INVESTMENT_PLAN = 'configurar estrategia';
const EVENT_DETAIL_SELECTED_STRATEGY = 'estrategia';
const EVENT_ACTION_SHOW_PORTFOLIO_DISTRIBUTION = 'ver distribucion de la cartera seleccionada';
const EVENT_CATEGORY_SHOW_PORTFOLIO_DISTRIBUTION = 'interaccion en seccion strategies-graph';
const EVENT_ACTION_SHOW_PORTFOLIO_MANAGMENT_CONTRACT = 'Detalle contrato de gestión discrecional';
const EVENT_CATEGORY_SHOW_PORTFOLIO_MANAGMENT_CONTRACT = 'interaccion en seccion investment-plan';
const EVENT_ACTION_SHOW_RISK_INDEX = 'ver indices de riesgo';
const EVENT_CATEGORY_SHOW_RISK_INDEX = 'interaccion en seccion investment-plan';
const EVENT_CATEGORY_OBJECTIVE_CONFIGURATION = 'configura tu objetivo';
const EVENT_ACTION_OBJECTIVE_CONFIGURATION = 'configurar objetivo';
const EVENT_ACTION_LOGIN_ROBO = 'paso 0 - inicio';
const EVENT_DETAIL_LOGIN_ROBO = 'clave de acceso input text';
const EVENT_ACTION_PASSWORD_RECOVERY = 'paso 0 - inicio';
const EVENT_DETAIL_PASSWORD_RECOVERY = 'recuperar clave de acceso';
const EVENT_DETAIL_LOGIN_ROBO_SUCCESS = 'clave de acceso exito';
const EVENT_DETAIL_RETAKE_TEST = 'retomar';
const EVENT_DETAIL_QUESTION_LOAD = 'impresion pregunta';
const EVENT_DETAIL_RESULT_LOAD = 'impresion resultado';
const EVENT_DETAIL_BUTTON_NEXT = 'siguiente';
const EVENT_DETAIL_BUTTON_PREV = 'anterior';
const EVENT_DETAIL_CHOICE = 'eleccion';
const EVENT_DETAIL_TOOLTIP = 'tooltip';
const EVENT_DETAIL_EXIT = 'salir';
const EVENT_DETAIL_CLOSE_MODAL = 'salir modal - cerrar';
const EVENT_DETAIL_MODAL_STEP_4 = 'experiencia modal';
const EVENT_DETAIL_MODAL_STEP_6 = 'tiempo modal';
const EVENT_DETAIL_MODAL_OPEN_DEFAULT = 'abrir';
const EVENT_DETAIL_BUTTON_CLOSE = 'cerrar';
const EVENT_DETAIL_VERIFY_MODAL = 'verificar modal';
const EVENT_DETAIL_VERIFY = 'verificar';
const EVENT_DETAIL_RECONSIDER_BUTTON = 'reconsiderar';
const EVENT_DETAIL_CLICK_INPUT = 'click text field';
const EVENT_DETAIL_CLICK_SLIDER = 'toolbar';
const EVENT_DETAIL_MODAL_STEP_7 = 'porcentaje perdida modal';
const EVENT_DETAIL_INCOMINGS = 'ingresos';
const EVENT_DETAIL_OUTGOINS = 'gastos';
const EVENT_DETAIL_FINISH = 'finalizar';
const EVENT_DETAIL_MODAL_EXIT_OPEN = 'salir modal - abrir';
const EVENT_DETAIL_MODAL_EXIT_NEXT = 'salir modal - siguiente';
const EVENT_ACTION_RA_REJECTED = 'continuar sin roboadvisor';
const EVENT_CATEGORY_RA_REJECTED = 'robo advisor rechazado';
const PRODUCT_NAME_ROBO = 'robo cartera';
const CALL_ME_BACK = 'call me back';
const SIMULATION_GBI_NAME = 'inversion por objetivos';
const SIMULATION_ROBO_NAME = 'cartera de inversion';
const EVENT_DETAIL_RENTABILITY_DETAIL = 'detalle proyecciones retabilidad';
const FIOC_NAME = 'tu actividad';
const EVENT_DETAIL_SIGN = 'firmar';
const EVENT_DETAIL_OTP = 'codigo de confirmacion';
const EVENT_DETAIL_OTP_FIELD = EVENT_DETAIL_OTP + ' text field';
const EVENT_DETAIL_OTP_SUCCESS = EVENT_DETAIL_OTP + ' exito';
const EVENT_DETAIL_OTP_FAILURE = EVENT_DETAIL_OTP + ' error';
const EVENT_DETAIL_OTP_NEW = EVENT_DETAIL_OTP + 'solicitar nuevo';
const EVENT_DETAIL_RECURRING_CONTRIBUTION = 'aportaciones periodicas';
const EVENT_ACTION_RISK_MODAL = 'modal indices de riesgo';
const EVENT_DETAIL_UNDERSTOOD = 'entendido';
const EVENT_DETAIL_VIEW = 'vista';
const EVENT_DETAIL_RECOVER_HERE = 'recuperalo aqui';
const EVENT_DETAIL_PROJECTION = 'proyeccion de cartera';
const EVENT_ACTION_CURRENT_DISTRIBUTION = 'chevron distribucion actual';
const EVENT_ACTION_DISTRIBUTION_DETAIL = 'chevron detalle de distribucion';
const EVENT_DETAIL_WITHOUT_OBJECTIVE = 'sin objetivo';
const EVENT_DETAIL_WITHOUT_DATE = 'sin fecha';
const EVENT_DETAIL_LEGAL_INFO = 'informacion legal';
const IBAN_DOCUMENTATION_NAME = 'documentacion iban';
const EVENT_ACTION_COPY_IBAN = 'copiar IBAN';
const INVESTMENT_EXPERIENCE = {
    105: 'Depositos bancarios',
    106: 'Renta fija',
    107: 'Renta variable',
    108: 'Fondos, planes, seguros de inversion y ETFs',
    109: 'Productos estructurados con garantia',
    110: 'Productos estructurados sin garantia',
    111: 'Bonos convertibles y bonos complejos',
    112: 'Participaciones preferentes, deuda subordinada y renta fija con derivados implicitos',
    113: 'Productos inmobiliarios',
    114: 'Productos de capital de riesgo',
    115: 'Derivados en mercados organizados',
    116: 'Derivados OTC',
};
const INVESTMENT_EXPERIENCE_BUTTONS_ANSWERS = {
    answer1: 'ninguna',
    answer2: 'una',
    answer3: 'dos o mas',
};
const INVEST_PROFILE = {
    1: 'Kuala Lumpur',
    2: 'Shangai',
    3: 'Taipei',
    4: 'New York',
    5: 'Dubai',
};

const EVENT_ONBOARDING = 'eventos onboarding';
const ONBOARDING_SUCCESS = 'onboarding exito';
const EVENT_CREDIT_CARD = 'abre tu cuenta/card amazon';
const EVENT_VALID_IBAN = 'iban correcto';
const EVENT_ACEPT_MODAL = '<volver a intentarlo>';
const EVENT_CLOSE_MODAL = '<cerrar>';
const IBAN_MODAL_VALIDATION = 'modal validacion iban';
const IBAN_MODAL_VALIDATION_STATUS = {
    SUCCESS: 'exito',
    CHECKING: 'comprobando',
    FAILED: 'error-input',
};

const EVENT_SIGNATURE_KEY = 'clave-firma';

export default {
    EVENT_CREDIT_CARD,
    EVENT_ONBOARDING,
    ONBOARDING_SUCCESS,
    TEST_PROCESS_STEP,
    TEST_PROCESS_STEP_START,
    TEST_PROCESS_STEP_STEP_1,
    TEST_PROCESS_STEP_STEP_2,
    TEST_PROCESS_STEP_STEP_3,
    TEST_PROCESS_STEP_STEP_4,
    TEST_PROCESS_STEP_STEP_5,
    TEST_PROCESS_STEP_STEP_6,
    TEST_PROCESS_STEP_STEP_7,
    TEST_PROCESS_STEP_STEP_8,
    TEST_PROCESS_STEP_STEP_9,
    TEST_PROCESS_STEP_STEP_10,
    TEST_PROCESS_STEP_SUCCESS,
    TEST_PROCESS_STEP_ERROR,
    PROCESS_TYPE_ROBO,
    PROCESS_TYPE_ROBO_TI,
    PROCESS_TYPE_GBI,
    PROCESS_TYPE_GBI_TI,
    TEST_PROCESS_DETAIL_FAILURE,
    EVENT_CATEGORY_SUITABILITY_TEST,
    EVENT_ACTION_MODAL_VIEW,
    EVENT_ACTION_EXIT_TEST,
    EVENT_ACTION_RETURN,
    EVENT_ACTION_SUITABILITY_TEST_GOAL_SELECTION,
    EVENT_DETAIL_SUITABILITY_TEST_INVESTMENT_GOAL,
    EVENT_CATEGORY_SUITABILITY_TEST_MODAL,
    EVENT_ACTION_CONTINUE,
    EVENT_CATEGORY_INVESTMENT_PLAN,
    EVENT_ACTION_INVESTMENT_PLAN,
    INVEST_PROFILE,
    EVENT_ACTION_SHOW_PORTFOLIO_DISTRIBUTION,
    EVENT_ACTION_SHOW_PORTFOLIO_MANAGMENT_CONTRACT,
    EVENT_ACTION_SHOW_RISK_INDEX,
    EVENT_CATEGORY_OBJECTIVE_CONFIGURATION,
    EVENT_ACTION_OBJECTIVE_CONFIGURATION,
    EVENT_CATEGORY_SHOW_PORTFOLIO_MANAGMENT_CONTRACT,
    EVENT_CATEGORY_SHOW_RISK_INDEX,
    EVENT_CATEGORY_SHOW_PORTFOLIO_DISTRIBUTION,
    EVENT_DETAIL_LOGIN_ROBO,
    EVENT_ACTION_LOGIN_ROBO,
    EVENT_ACTION_PASSWORD_RECOVERY,
    EVENT_DETAIL_PASSWORD_RECOVERY,
    EVENT_DETAIL_LOGIN_ROBO_SUCCESS,
    EVENT_DETAIL_RETAKE_TEST,
    EVENT_DETAIL_QUESTION_LOAD,
    EVENT_DETAIL_BUTTON_NEXT,
    EVENT_DETAIL_BUTTON_PREV,
    EVENT_DETAIL_TOOLTIP,
    EVENT_DETAIL_CHOICE,
    EVENT_DETAIL_EXIT,
    EVENT_DETAIL_CLOSE_MODAL,
    INVESTMENT_EXPERIENCE,
    INVESTMENT_EXPERIENCE_BUTTONS_ANSWERS,
    EVENT_DETAIL_MODAL_STEP_4,
    EVENT_DETAIL_MODAL_OPEN_DEFAULT,
    EVENT_DETAIL_BUTTON_CLOSE,
    EVENT_DETAIL_VERIFY,
    EVENT_DETAIL_VERIFY_MODAL,
    EVENT_DETAIL_RECONSIDER_BUTTON,
    EVENT_DETAIL_MODAL_STEP_6,
    EVENT_DETAIL_CLICK_INPUT,
    EVENT_DETAIL_CLICK_SLIDER,
    EVENT_DETAIL_MODAL_STEP_7,
    EVENT_DETAIL_INCOMINGS,
    EVENT_DETAIL_OUTGOINS,
    EVENT_DETAIL_FINISH,
    TEST_PROCESS_STEP_FAILURE,
    EVENT_DETAIL_RESULT_LOAD,
    EVENT_DETAIL_MODAL_EXIT_OPEN,
    EVENT_DETAIL_MODAL_EXIT_NEXT,
    EVENT_CATEGORY_RA_REJECTED,
    EVENT_ACTION_RA_REJECTED,
    PRODUCT_NAME_ROBO,
    CALL_ME_BACK,
    SIMULATION_GBI_NAME,
    EVENT_DETAIL_RENTABILITY_DETAIL,
    FIOC_NAME,
    EVENT_DETAIL_SIGN,
    EVENT_DETAIL_OTP,
    EVENT_DETAIL_OTP_FIELD,
    EVENT_DETAIL_OTP_FAILURE,
    EVENT_DETAIL_OTP_SUCCESS,
    EVENT_DETAIL_OTP_NEW,
    SIMULATION_ROBO_NAME,
    EVENT_DETAIL_RECURRING_CONTRIBUTION,
    EVENT_DETAIL_UNDERSTOOD,
    EVENT_ACTION_RISK_MODAL,
    EVENT_DETAIL_VIEW,
    EVENT_DETAIL_PROJECTION,
    EVENT_ACTION_DISTRIBUTION_DETAIL,
    EVENT_ACTION_CURRENT_DISTRIBUTION,
    EVENT_DETAIL_WITHOUT_DATE,
    EVENT_DETAIL_WITHOUT_OBJECTIVE,
    EVENT_DETAIL_SELECTED_STRATEGY,
    IBAN_DOCUMENTATION_NAME,
    EVENT_ACTION_COPY_IBAN,
    EVENT_DETAIL_LEGAL_INFO,
    EVENT_VALID_IBAN,
    EVENT_ACEPT_MODAL,
    EVENT_CLOSE_MODAL,
    EVENT_DETAIL_RECOVER_HERE,
    IBAN_MODAL_VALIDATION,
    IBAN_MODAL_VALIDATION_STATUS,
    EVENT_SIGNATURE_KEY,
};
